import * as React from 'react';

import type { TimeSheetInfoVM, TimeSheetEntryInfoVM } from 'ab-viewModels/workOrder/submitForReviewRecap';

import TimeSheetEmployee from '../Shared/ReportsSummary/TimeSheets/TimeSheetEmployee';

interface OwnProps {
	timeSheetEntriesByAccountIdMap: Nullable<{ [accountId: number]: TimeSheetEntryInfoVM[]; }>;
	signedTimeSheets: TimeSheetInfoVM[];
	unsignedTimeSheets: TimeSheetInfoVM[];
	timezone: Nullable<string>;
}

type Props = OwnProps;

const TimeSheets: React.FC<Props> = (props) => {
	const { timeSheetEntriesByAccountIdMap, signedTimeSheets, unsignedTimeSheets, timezone } = props;

	const renderEmployee = React.useCallback((timeSheet: TimeSheetInfoVM) => {
		return (
			<TimeSheetEmployee
				key={timeSheet.accountId}
				showWorkShift={true}
				timeSheet={timeSheet}
				timeSheetEntries={timeSheetEntriesByAccountIdMap?.[timeSheet.accountId] ?? []}
				timezone={timezone}
			/>
		);
	}, [timeSheetEntriesByAccountIdMap, timezone]);

	if (!signedTimeSheets.length && !unsignedTimeSheets.length) {
		return null;
	}

	const hasUnsignedTimeSheets = !!unsignedTimeSheets.length;
	const hasSignedTimeSheets = !!signedTimeSheets.length;

	return (
		<div className="report-submit-modal__section">
			<div className="report-submit-modal__section__title">TIME SHEETS</div>
			{hasUnsignedTimeSheets &&
				<div className="report-submit-modal__time-sheet-section">
					<div className="report-submit-modal__time-sheet-section__title">Sign And Approve Time Sheets On Behalf Of</div>
					<div className="report-submit-modal__section__list">
						{unsignedTimeSheets.map(renderEmployee)}
					</div>
				</div>
			}
			{hasSignedTimeSheets &&
				<div className="report-submit-modal__time-sheet-section">
					{hasUnsignedTimeSheets && <div className="report-submit-modal__time-sheet-section__title">Approve Signed Time Sheets</div>}
					<div className="report-submit-modal__section__list">
						{signedTimeSheets.map(renderEmployee)}
					</div>
				</div>
			}
		</div>
	);
};

export default React.memo(TimeSheets);
